let accessToken: string | null = null;

export function setStoredAccessToken(token: string | null): void {
  accessToken = token ?? null;
}

export function getStoredAccessToken(): string | null {
  return accessToken;
}

export function clearStoredAccessToken(): void {
  accessToken = null;
}
